interface EntradaDoCache<T> {
	expiraEm: number
	promessa: Promise<T>
}

export function criarCachePorTempo<T>(duracaoEmMs: number, agora: () => number = Date.now) {
	const entradas = new Map<string, EntradaDoCache<T>>()

	return function buscar(chave: string, carregar: () => Promise<T>): Promise<T> {
		const existente = entradas.get(chave)
		if (existente && existente.expiraEm > agora()) return existente.promessa

		const promessa = carregar()
		entradas.set(chave, { expiraEm: agora() + duracaoEmMs, promessa })
		promessa.catch(() => {
			const atual = entradas.get(chave)
			if (atual && atual.promessa === promessa) entradas.delete(chave)
		})

		return promessa
	}
}
